module.exports = __webpack_public_path__ + "static/media/wheelchair.089f5e01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/amenities/wheelchair.svg
// module id = 589
// module chunks = 0